<template>
    <div>
        <div class="mainbox no">
            <div
                data-aos="fade-left"
                data-aos-delay="500"
                data-aos-easing="ease-in-out"
                data-aos-anchor-placement="top-center"
                class="imgmobile"
            >
                <img src="../../assets/images/mobile.png" alt="">
            </div>
            <div
                data-aos="fade-left"
                data-aos-delay="600"
                data-aos-easing="ease-in-out"
                data-aos-anchor-placement="top-center"
            >
                <span>{{lang[local].part1_txt1}}</span>
            </div>
            <div
                data-aos="fade-left"
                data-aos-delay="800"
                data-aos-easing="ease-in-out"
                data-aos-anchor-placement="top-center"
            >
                <span>{{lang[local].part1_txt2}}<br />{{lang[local].part1_txt3}}</span>
            </div>
            <div
                data-aos="fade-left"
                data-aos-delay="1000"
                data-aos-easing="ease-in-out"
                data-aos-anchor-placement="top-center"
            >
                <span style="font-size:15px;">{{lang[local].part1_txt4}}</span><br />
                <span>{{lang[local].part1_txt5}}</span>
            </div>
            <div
                data-aos="fade-left"
                data-aos-delay="1200"
                data-aos-easing="ease-in-out"
                data-aos-anchor-placement="top-bottom"
                data-aos-offset="120"
            >
                <Button type="error" size="large" @click="$router.push('/app')">{{lang[local].part1_txt6}}</Button>
            </div>
            
        </div>
    </div>    
</template>

<script>
import {Button} from "iview"
import {mapState} from "vuex"
export default {
    components:{
        Button,
    },
    data () {
        return{
            
        }
    },
    computed:
        mapState(['lang','local','skin'])
    ,
    mounted () {

    },
    methods:{

    }
    // render (h) {
    //     return (
    //     )
    // }
}
</script>

<style lang="less" scoped>
    .mainbox{
        position: relative;
        &>div{padding-left:40px;}
        &>div:nth-child(2){font-size:40px;color:#D6F640;margin-top:40px;}
        &>div:nth-child(3){font-size:60px;line-height: 55px;font-weight:100;margin:20px 0}
        &>div:nth-child(4){font-size:25px;}
        &>div:nth-child(5){margin-top:30px;}
        &>div:nth-child(1){color:#D6F640;position:absolute;right:60px;top:20px;}
    }

</style>

